import Immutable from 'immutable';

export type StudioId = string;

export interface RawStudioProject {
  id: StudioId;
  guid: string;
  name: string;
  restricted: boolean;
  created: string;
  ownerNameIdentifier: string;
  ownerEmail: string;
}

export interface StudioProjectData {
  id: StudioId;
  guid: string;
  name: string;
  restricted: boolean;
  created: string;
  ownerNameIdentifier: string;
  ownerEmail: string;
}

const defaultValues: StudioProjectData = {
  id: '',
  guid: '',
  name: '',
  restricted: false,
  created: '',
  ownerNameIdentifier: '',
  ownerEmail: '',
};

export const StudioProjectFactory = Immutable.Record(
  defaultValues,
  'StudioProject'
);

export class StudioProject extends StudioProjectFactory {
  static deserialize(rawStudio: RawStudioProject): StudioProject {
    return new StudioProject({
      ...rawStudio,
    });
  }
}

export type StudioProjectList = Immutable.List<StudioProject>;

export type StudioProjectMap = Immutable.OrderedMap<StudioId, StudioProject>;
